define.alias("shared/components/shared/social/tiktok-details", "calendar/components/shared/social/tiktok-details");